module.exports = __webpack_public_path__ + "static/fonts/Arita-buriB.f62fcd9.otf";